// TODO: Create actions
export const Actions = {
    USPS_ZIP_INITIALIZE: 'USPS_ZIP_INITIALIZE',
    OPEN_LEAD_FORM_MODAL: 'OPEN_LEAD_FORM_MODAL',
    CLOSE_LEAD_FORM_MODAL: 'CLOSE_LEAD_FORM_MODAL',
    LEAD_FORM_SUBMITTED: 'LEAD_FORM_SUBMITTED',
    LEAD_FORM_SUBMISSION_SUCCESS: 'LEAD_FORM_SUBMISSION_SUCCESS',
    LEAD_FORM_SUBMISSION_FAILURE: 'LEAD_FORM_SUBMISSION_FAILURE',
    LEAD_FORM_CONTINUE_SUBMISSION: 'LEAD_FORM_CONTINUE_SUBMISSION',
    LEAD_FORM_FIRSTNAME_BLUR: 'LEAD_FORM_FIRSTNAME_BLUR',
    LEAD_FORM_LASTNAME_BLUR: 'LEAD_FORM_LASTNAME_BLUR',
    LEAD_FORM_EMAIL_BLUR: 'LEAD_FORM_EMAIL_BLUR',
    LEAD_FORM_PHONE_BLUR: 'LEAD_FORM_PHONE_BLUR',
    LEAD_FORM_MESSAGE_BLUR: 'LEAD_FORM_MESSAGE_BLUR',
    REINITIALIZE_LEAD_FORM: 'REINITIALIZE_LEAD_FORM',
    SET_LEAD_FORM_MODAL_ERROR: 'SET_LEAD_FORM_MODAL_ERROR',
    OFFER_SUBMISSION_FAILURE: 'OFFER_SUBMISSION_FAILURE',
    OFFER_SUBMISSION_SUCCESS: 'OFFER_SUBMISSION_SUCCESS',
    OFFER_SUBMISSION_REQUEST: 'OFFER_SUBMISSION_REQUEST',
    INIT_SUCCESS: 'INIT_SUCCESS',
    LEAD_FORM_ANALYTICS_ACTION: 'LEAD_FORM_ANALYTICS_ACTION',
    LEAD_FORM_CCPA: 'LEAD_FORM_CCPA',
    UPDATED_SHOPPER: 'UPDATED_SHOPPER',
    FETCH_QUESTIONS_OR_PAYMENT: 'FETCH_QUESTIONS_OR_PAYMENT',
    USPS_ZIP_REQUEST: 'USPS_ZIP_REQUEST',
    USPS_ZIP_FAILURE: 'USPS_ZIP_FAILURE',
    USPS_ZIP_SUCCESS: 'USPS_ZIP_SUCCESS',
    SUMMARY_REMOVE_TRADE_IN_CLICKED: 'SUMMARY_REMOVE_TRADE_IN_CLICKED'
};
